import { AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { IDriftEntryDto } from 'src/app/models/features/schema-drift/IDriftEntryDto';
import { HeaderService } from '../../../../services/_app/header/header.service';
import { SchemaDriftService } from '../../../../services/_app/schema-drift/schema-drift.service';
import { AuditProfileService } from '../../../../services/audit-profile/audit-profile.service';
import { BaseComponent } from '../../../base/base.component';
import { NgxChartsModule, Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-drift-intensity-matrix',
  templateUrl: './drift-intensity-matrix.component.html',
  styleUrls: ['./drift-intensity-matrix.component.css']
})
export class DriftIntensityMatrixComponent extends BaseComponent implements OnInit, AfterViewInit {
  // *********************
  // variables declaration
  // *********************

  // private
  // ********

  // public
  // ******
  @Input() driftData: any;
  @Input() isDark = false;

  public matrixData: any[] = [];
  public view: [number, number] = [900, 360];
  public showLegend = true;
  public xAxisLabel = 'Date';
  public yAxisLabel = 'Schema Changes';
  public legendTitle = 'Change Type';
  public colorScheme: Color = {
    name: 'schemaDrift',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#e5f3ff', '#93c5fd', '#3b82f6', '#1e40af']
  };

  constructor(private auditProfileService: AuditProfileService,
    private headerService: HeaderService,
    private schemaDriftService: SchemaDriftService,
    private router: Router) {
    super();
  }

  // ***************
  // lifecycle hooks
  // ***************

  override async ngOnInit() {
    await this.housekeeping();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('DriftTrendChartComponent - ngOnChanges', changes);
    if (changes['driftData']) {
      this.tryBuild();
    }
  }

  // *******
  // methods
  // *******

  // public
  // ******

  public getTotal(seriesGroup: any): number {
    return seriesGroup?.series?.reduce((acc: number, cur: any) => acc + cur.value, 0) || 0;
  }

  // private
  // *******

  private async housekeeping() {
    this.tryBuild();
  }

  private tryBuild(): void {
    const entries = this.driftData?.ParsedDrift;

    if (!entries || entries.length === 0) {
      this.matrixData = [];

      return;
    }

    this.matrixData = this.buildMatrix(entries);
  }

  private buildMatrix(entries: IDriftEntryDto[]): any[] {
    const tableMap = new Map<string, Map<string, number>>();

    for (const e of entries) {
      if (!tableMap.has(e.table)) tableMap.set(e.table, new Map<string, number>());
      const dateMap = tableMap.get(e.table)!;
      dateMap.set(e.date, (dateMap.get(e.date) || 0) + 1);
    }

    return Array.from(tableMap.entries()).map(([table, dateMap]) => ({
      name: table,
      series: Array.from(dateMap.entries()).map(([date, count]) => ({
        name: date,
        value: count
      }))
    }));
  }
}
